import React from 'react';
import { FiMail } from 'react-icons/fi';
import AppModal from '../../common/AppModal';

const TemplatePrev = ({ showModal, handleClose, selectedPrevData, handleEditorChange }) => {
    return (
        <AppModal
            show={showModal}
            onClose={handleClose}
            icon={<FiMail size={17} color="#fff" />}
            title={selectedPrevData?.templateName || 'Email Preview'}
            subtitle={selectedPrevData?.subject ? `Subject: ${selectedPrevData.subject}` : 'Template preview'}
            maxWidth="700px"
        >
            {selectedPrevData ? (
                <div style={previewStyles.wrap}>
                    {/* Email envelope top bar */}
                    <div style={previewStyles.envelope}>
                        <span style={previewStyles.envelopeLabel}>Preview</span>
                        {selectedPrevData.subject && (
                            <span style={previewStyles.subjectChip}>{selectedPrevData.subject}</span>
                        )}
                    </div>

                    {/* Email body */}
                    <div style={previewStyles.body}>
                        {typeof selectedPrevData.templateData === 'string' ? (
                            <div
                                dangerouslySetInnerHTML={{ __html: selectedPrevData.templateData }}
                            />
                        ) : (
                            <pre style={previewStyles.pre}>
                                {JSON.stringify(selectedPrevData.templateData, null, 2)}
                            </pre>
                        )}
                    </div>
                </div>
            ) : (
                <div style={previewStyles.empty}>No preview data available.</div>
            )}
        </AppModal>
    );
};

const previewStyles = {
    wrap: {
        border: '1px solid #e5e7eb',
        borderRadius: '10px',
        overflow: 'hidden',
        background: '#fff',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
    },
    envelope: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 18px',
        background: 'linear-gradient(135deg, #eaf3ec 0%, #f0f7f4 100%)',
        borderBottom: '1px solid rgba(26, 92, 50, 0.10)',
    },
    envelopeLabel: {
        fontSize: '11px',
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: '#1a5c32',
    },
    subjectChip: {
        fontSize: '12px',
        color: '#374151',
        background: '#fff',
        border: '1px solid #d1fae5',
        borderRadius: '20px',
        padding: '2px 10px',
        fontWeight: '500',
    },
    body: {
        padding: '24px 28px',
        fontSize: '14px',
        lineHeight: '1.7',
        color: '#1f2937',
        overflowY: 'auto',
        maxHeight: '55vh',
    },
    pre: {
        fontSize: '12px',
        color: '#374151',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        margin: 0,
    },
    empty: {
        textAlign: 'center',
        padding: '48px 0',
        color: '#9ca3af',
        fontSize: '14px',
    },
};

export default TemplatePrev;
